import Vue from 'vue'
import Router from 'vue-router'
import ProchainPassage from '../pages/ProchainPassage'
import DetailCarte from '../pages/DetailCarte'
import Home from '../pages/Home'
import Horaires from '../pages/Horaires'
import Tarifs from '../pages/Tarifs'
import Reserver from '../pages/Reserver'
import Arrets from '../pages/Arrets'
import RecupCarte from '../pages/RecupCarte'
import Contact from '../pages/Contact'
import VueMatomo from 'vue-matomo'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '',
      name: 'Home',
      component: Home
    },
    {
      path: '/fiche-horaire',
      name: 'Horaires',
      component: Horaires
    },
    {
      path: '/reserver',
      name: 'Reserver',
      component: Reserver
    },
    {
      path: '/tarifs',
      name: 'Tarifs',
      component: Tarifs
    },
    {
      path: '/recuperation-carte',
      name: 'RecupCarte',
      component: RecupCarte
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/arrets',
      name: 'Arrets',
      component: Arrets
    },
    {
      path: '/arret=:stopName',
      name: 'ProchainPassage',
      component: ProchainPassage
    },
    {
      path: '/carte/:tripId/:stopId/:sequence',
      name: 'Detail',
      component: DetailCarte,
      props: true
    }
  ]
})

Vue.use(VueMatomo, {
  host: 'https://pretapartir.matomo.cloud/',
  siteId: 17,
  trackerFileName: 'matomo',
  enableLinkTracking: true,
  trackInitialView: true,
  trackPageView: true,
  router: router,
  debug: false,
})

router.afterEach((to, from) => {
  window.dataLayer = window.dataLayer || []

  function gtag () {
    dataLayer.push(arguments)
  }
  gtag('event', 'page_view', {
    page_title: to.name,
    page_location: to.fullPath,
    page_path: to.path,
    send_to: 'G-JYL6JT5P1T'
  })
  gtag('js', new Date())
  gtag('config', 'G-JYL6JT5P1T')
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js